import React, { useMemo } from 'react';
//import Head from 'next/head';
import { useRouter } from 'next/router';
import Head from 'next/head';
import {  getISODateNow, getSeoMetaTags } from 'utils/common.utils';
import notionDataService from 'services/notiondata.service';
import { EyeHealthItem } from 'constants/notionDataPages';
import GlobalSeoMetaTags from 'components/GlobalSeoMetaTags/GlobalSeoMetaTags';
import { GetServerSideProps } from 'next';

export default function EyeHealth({  list, seoMetaTags }: { list?: EyeHealthItem[] |undefined; seoMetaTags: any }) {
  const router = useRouter();

    //get EyeHealthItem from list with slug 'glossary' with useMemo
    const glossaryItem = useMemo(
        () => list?.find((item) => item.slug === 'glossary'),
        [list]
      );

    //filter list array with useMemo to remove item with slug 'glossary'
    const filteredList = useMemo(
        () => list?.filter((item) => item.slug !== 'glossary'),
        [list]
      );

      

    //get latest publishDate from list array with useMemo
    const publishDate = useMemo(
        () => list?[...list].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())[0].publishDate:getISODateNow(),
        [list]
      );
  
    //get latest lastEditedTime from list array use sort without changing array
    const lastEditedTime = useMemo(
        () => list?[...list].sort((a, b) => new Date(b.lastEditedTime!).getTime() - new Date(a.lastEditedTime!).getTime())[0].lastEditedTime:getISODateNow(),
        [list]
        );

  if (router.isFallback) {
    return (
      <div className="flex h-[70vh] items-center justify-center">
        Loading...
      </div>
    );
  }
  const isInternational = router.locale === 'international';
  const baseUrl = isInternational ? '/' : '/' + router.locale + '/';

  const countryPageName = isInternational ? 'Dresden' : 'Dresden ' + router.locale?.toUpperCase();

  //get all title fields from list array into a string
  const titles = filteredList?.map((item) => item.title);
  const titlesString = titles?.join(', ');

  const metaDescription = glossaryItem && glossaryItem?.metaDescription ? glossaryItem?.metaDescription : 'Dresden Vision - Eye Health - Glossary - ' + titlesString;

  return (
    <div className="w-full px-12 pt-8 pb-12 lgx:pt-4 lgx:pb-0 mdx:px-4">
        <Head>
            <title>{`Eye Health - ${countryPageName}`}</title>
            <meta property="description" content={metaDescription}/>
            <meta property="og:type" content="article"/>
            <meta property="og:title" content="Eye Health"/>
            <meta property="og:description" content={metaDescription}/>
            <meta property="og:site_name" content={countryPageName}/>
            <meta property="article:published_time" content={publishDate} />
            <meta property="article:modified_time" content={lastEditedTime}/>
            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:label1" content="Written by"/>
            <meta name="twitter:data1" content="Dresden Vision"/>
            <meta name="twitter:label2" content="Est. reading time"/>
            <meta name="twitter:data2" content="1 minute"/>
        </Head>
      <div className="relative mx-auto max-w-[1224px] px-4 font-sans leading-[1.7] text-brand-black75">
      <ol className="flex xsmx:flex-wrap mb-8">
        <li className="flex mr-2">
          <div className="flex items-center group">
            <a href={baseUrl}>
              <span className="font-sans flex items-center font-normal text-sm text-brand-grey75">Dresden Vision</span>
            </a>
          </div>
        </li>
       
           <li className="flex mr-2"><span className="mr-2 text-brand-grey150">&gt;</span>
          <div className="flex items-center group">
           
              <span className="font-sans flex items-center font-normal text-sm text-brand-black75">
                Eye Health
              </span>
          </div> </li>
       
      </ol>
        <h1 id="h-glossary" className="mx-auto mb-10 max-w-screen-md text-4xl font-bold leading-none mdx:text-2xl">
            Eye Health
        </h1>
        <ul className="mx-auto mb-10 max-w-screen-md leading-none mdx:text-2xl pl-8 list-disc">
            {filteredList?.map((item, index) => (
                <li key={index}>
                    <span className="has-inline-color" style={{color: '#00a3ff'}}>
                    <a className="text-lg font-medium my-[8px]" href={baseUrl + 'eye-health/' + item.slug}>{item.title}</a>
                    </span>
                </li>
            ))}
        </ul>
      </div>
      <GlobalSeoMetaTags  seoMetaTags={seoMetaTags} />
    </div>
  );
}



export const getServerSideProps: GetServerSideProps = async ({ locale }) => {

    const listAllRegion: EyeHealthItem[] = await notionDataService.getPageList('eyehealth', locale);
    //filter list by checking if region array contains locale or empty


    const seoMetaTags = await getSeoMetaTags('/eye-health/glossary', locale);
 

    return {
        props: {
            list:listAllRegion,
            seoMetaTags
        }
      };
    
  
};
